export default {
	vipBenefits: {
		salaryTitle: 'Lương VIP',
		benefitsTitle: 'Quyền lợi',
		yourVipProgress: 'Tiến trình VIP của bạn',
		progressToVip: '{percent}% đến VIP {level}',
		vipMax: 'Đã đạt cấp tối đa',
		vipLevelBenefits: 'Cấp độ & Quyền lợi VIP',
		betXpRule: 'Cược {amount} = {xp}EXP',
		btnReceive: 'Nhận',
		btnJoinIn: 'Tham gia',
		btnReceived: 'Đã nhận',
		btnExpired: 'Hết hạn',
		btnNotSettled: 'Chưa thanh toán',
		btnComingSoon: 'Sắp ra mắt',
		btnViewMore: 'Xem thêm',
		btnContactNow: 'Liên hệ',
		guestTitleLevelup: 'Thưởng Lên Cấp',
		guestTitleDaily: 'Lương Hằng Ngày',
		guestTitleWeekly: 'Lương Hằng Tuần',
		guestTitleMonthly: 'Lương Hằng Tháng',
		guestTitleCashback: 'Hoàn Tiền',
		guestTitleRescue: 'Thưởng Cứu Trợ',
		guestTitleEvents: 'Sự Kiện VIP',
		guestTitleSupport: 'Hỗ Trợ VIP',
		guestDescLevelup: 'Nhận thưởng một lần mỗi khi bạn đạt cấp VIP mới.',
		guestDescDaily: 'Nhận thưởng lương hằng ngày khi cấp VIP của bạn tăng lên.',
		guestDescWeekly: 'Nhận thưởng lương hằng tuần khi cấp VIP của bạn tăng lên.',
		guestDescMonthly: 'Nhận thưởng lương hằng tháng khi cấp VIP của bạn tăng lên.',
		guestDescCashback: 'Nhận hoàn tiền cho chi tiêu trò chơi của bạn.',
		guestDescRescue: 'Nhận thưởng cứu trợ để giúp bạn phục hồi.',
		guestDescEvents: 'Cấp VIP càng cao mở khóa càng nhiều phần thưởng sự kiện độc quyền.',
		guestDescSupport: 'Hỗ trợ VIP chuyên biệt để được trợ giúp nhanh hơn.',
		comingSoonHint: 'Quyền lợi sắp ra mắt, hãy đón chờ',
		receiveSuccess: 'Nhận thưởng thành công',
		receiveFailed: 'Nhận thưởng thất bại',
		typeUpgrade: 'Thưởng Lên Cấp',
		typeDailySalary: 'Lương ngày',
		typeWeeklySalary: 'Lương tuần',
		typeMonthlySalary: 'Lương tháng',
		typeRebate: 'Hoàn tiền',
		typeRescue: 'Thưởng cứu trợ',
		typeVipActivity: 'Sự Kiện VIP',
		typeVipService: 'Hỗ Trợ VIP',
		tooltipRecharge: 'Nạp tiền {current}/{target}',
		tooltipBets: 'Cược {current}/{target}',
		progressRecharge: 'Nạp tiền',
		progressBets: 'Cược',
		descUpgradeBonus: 'Thưởng nâng cấp VIP{level} ×{count}',
		descDailySalary: 'Lương ngày VIP{level} ×{count}',
		descWeeklySalary: 'Lương tuần VIP{level} ×{count}',
		descMonthlySalary: 'Lương tháng VIP{level} ×{count}',
		descUpgradeBonusPlain: 'Thưởng nâng cấp VIP{level}',
		descDailySalaryPlain: 'Lương ngày VIP{level}',
		descWeeklySalaryPlain: 'Lương tuần VIP{level}',
		descMonthlySalaryPlain: 'Lương tháng VIP{level}',
		descRebate: 'Hoàn tiền Trò chơi VIP{level}',
		descRescue: 'Thưởng cứu trợ VIP{level}',
		descVipActivity: 'Cấp VIP càng cao mở khóa càng nhiều phần thưởng sự kiện độc quyền.',
		descVipService: 'Hỗ trợ VIP chuyên biệt để được trợ giúp nhanh hơn.',
		allBenefits: 'Tất cả Quyền lợi',
		vipClubTitle: 'VIP Club',
		more: 'Thêm',
		moreDesc: 'Vui lòng xem khuyến mãi của chúng tôi để biết thêm chi tiết.',
		promotions: 'Khuyến mãi',
		highlightsTitle: '8 Đặc quyền nổi bật',
		highlightSupport: 'Hỗ trợ VIP độc quyền',
		highlightLevelup: 'Thưởng thăng cấp',
		highlightSalary: 'Lương VIP',
		highlightRescue: 'Thưởng cứu trợ VIP',
		highlightGifts: 'Quà tặng\nVIP độc quyền',
		highlightEvents: 'Sự kiện VIP',
		highlightService: 'Dịch vụ\nVIP chuyên biệt',
		highlightWallet: 'Ví\ntín dụng VIP',
		currentLevel: 'Cấp hiện tại',
		keepPlayingReach: 'Tiếp tục chơi để đạt',
		higherLevelRewards: 'Cấp càng cao, phần thưởng càng lớn',
		levelUpUnlock: 'Nâng cấp để mở khóa các quyền lợi độc quyền và tận hưởng trải nghiệm cao cấp.',
		yourVipBenefits: 'Quyền lợi VIP của bạn',
		viewVipLevels: 'Xem cấp độ VIP',
		exclusiveBenefitsTitle: 'Quyền lợi độc quyền của bạn',
		tipExclusiveRewards: 'Phần thưởng độc quyền',
		tipHigherRakeback: 'Hoàn trả cao hơn',
		tipPrioritySupport: 'Hỗ trợ ưu tiên',
		levelGroupBronze: 'Bronze',
		levelGroupBrass: 'Brass',
		tableLevel: 'Cấp độ',
		tableRequiredXp: 'EXP yêu cầu',
		tableLevelUpBonus: 'Thưởng lên cấp',
		tableDailyRakeback: 'Hoàn trả hằng ngày',
		tableWeeklyLossback: 'Hoàn trả thua lỗ hằng tuần',
		signIn: 'Đăng nhập',
		vipClubDefaultDesc: 'Tham gia VIP Club của chúng tôi ngay để nhận quà tặng, ưu đãi và nhiều tính năng hấp dẫn.',
	},
};
